import O from "./O";
import G from './Getters';
import ContextMenu from "./ContextMenu";
import ImageManagement from "./ImageManagement";
import {FilesystemStore} from "./Contexts";
import { useState } from 'react';
import { FilesystemHierarchyContext } from './Contexts';
import { DIRECTORIES,IMAGE_SETS } from './RecordTypes';
import { FILESYSTEM_NAME } from './Filesystem';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { useStore } from 'react-redux';

const CheckMark = <CheckCircleIcon style={{ width:16,height:16, color:'green', }}/>;

const DefaultThumbnail = <div style={{width:16,height:16}}/>


export default function  ImageInsertionFilesystem({
  usedImageIds,
  onContextMenuEvent,
  focusedFsItemIds,
  focusedFsItemList,
  onFilesystemItemEvent,
  imageSetIdToInsert,
}){

  const [openPath,setOpenPath] = useState([]);
  
  const focusedImageSetId = focusedFsItemIds?.[0]?._id;
  const [loci, setLoci] = useState();

  const store = useStore();
  const state = store.getState();


 
  if( imageSetIdToInsert ){
  }


  return (
    <FilesystemHierarchyContext.Provider value={{
      /*
      [IMAGE_SETS]:(state,_id) => {
        if( _id === imageSetIdToInsert ){
          //return null;
        }
        return { children:[], expandable:false }
      } ,
      */
      /*
      [DIRECTORIES]:{
        childrenFilterArgs:{ excludedIds:imageSetIdToInsert?[imageSetIdToInsert]:null
        }
      }
      */
    }}>
      <FilesystemStore.Provider value={{ 
        isFilesystemItemSelected:(_id) => {
          return focusedFsItemIds.includes(_id);
        },
        onFilesystemItemEvent:(args) => {
          console.log(args);
          let { event } = args;
          onFilesystemItemEvent(args);
          if( args.item.type === "imageSets" ){

            let imageSet = G.getImageSet(state,args.item._id);
            let { images } = imageSet;
            if( images.length > 1 ){
              setLoci({x:event.clientX, y:event.clientY});
            }
          }
        },

        overrides:{
          thumbnail:{
            byId:Object.fromEntries(usedImageIds.map(_id => ([_id,CheckMark]))),
            default:DefaultThumbnail,
          }
        }





      }}>

        <div style={{width:300, 
          //border:'3px solid red'
        }} class="full-height">
          {false && <div>
            <pre>
            {JSON.stringify(usedImageIds)}
            </pre>
          </div>}
          <ImageManagement {...{
            columnMinWidths:{ filesystemName: 310 },
            columns:[{property:FILESYSTEM_NAME,display:"Name"}]
          }}/> 
        </div>






        {false && loci && <ContextMenu {...{
          setOpenPath,
          openPath,
          items:[{type:"add",title:"Add Channel",/*focusedFsItems*/}],
          ...loci,
          onClose:() => setLoci(),
          onEvent:(event) => {
            onContextMenuEvent(event);
            setLoci();
          },
          style:{
            background:'black',
            fontWeight:'bold',
            fontSize:16,
            color:'white',
            border:'1px solid #aaa',
            transform:'translate(10%, -50%)',

          }
        }}/>}

      </FilesystemStore.Provider>
    </ FilesystemHierarchyContext.Provider>
  )
}
